<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-tabs dark background-color="purple darken-3" show-arrows>
            <v-tabs-slider color="pink lighten-3"></v-tabs-slider>
            <v-tab> Datos Lavandería</v-tab>
            <v-tab> Preferencias Negocio </v-tab>
            <v-tab> Configurar App </v-tab>
            <v-tab-item>
              <DatosNegocio />
            </v-tab-item>
            <v-tab-item>
              <PreferenciasNegocio />
            </v-tab-item>
            <v-tab-item>
              <PrefereciasApp />
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DatosNegocio from "../components/AppConfig/PreferenciasNegocio/DatosNegocio";
import PreferenciasNegocio from "../components/AppConfig/PreferenciasNegocio/PreferenciasNegocio.vue";
import PrefereciasApp from "../components/AppConfig/PreferenciasApp/PrefereciasApp.vue";
export default {
  name: "Config",
  components: {
    DatosNegocio,
    PreferenciasNegocio,
    PrefereciasApp,
  },
};
</script>
<style>
.fix-to-bottom {
  position: absolute;
  bottom: 0;
}
</style>